import { UnknownAction } from "@reduxjs/toolkit";
import { ChatEventStatus, ChatbotProviderProps } from "@altimateai/ui-components/chatbotV2";

export enum PlaygroundUserViewEntities {
  NONE = "",
  SUMMARY = "summary",
  TEAM_SPENDS = "team_spends",
  ACCOUNTS_COST = "accounts_cost",
  DISCOVER = "discover",
  SNOWFLAKE_QUERY = "snowflake_query",
  SNOWFLAKE_DATASET = "snowflake_dataset",
  SNOWFLAKE_TABLE = "snowflake_table",
  SNOWFLAKE_WAREHOUSE = "snowflake_warehouse",
  SNOWFLAKE_USERS = "snowflake_users",
  SNOWFLAKE_ROLES = "snowflake_roles",
  DBT_MODEL = "dbt_model",
  EXPERIMENT = "experiment",
  INCIDENT = "incident",
  CONTRACT = "contract",
  COMPUTE_POOL = "compute_pool",
  SPACE = "space",
  ALERT = "alert",
  QUERY_GROUP = "query_group",
  DBT_CONFIG = "dbt_config",
  QUERY_RESULT = "query_result",
  DBT_DOCS = "dbt_docs",
  EXPORT_LINEAGE = "export_lineage",
  DATASTORE = "datastore",
  MCP_MEMORY = "mcp_memory",
  TEAMMATE = "teammate",
  USER_GROUP = "user_group",
  BI_REPORT = "bi_report",
  BI_USER_REPORT = "bi_user_report",
  KNOWLEDGE_SOURCE = "knowledge_source",
  SNOWFLAKE_JOB = "snowflake_job",
  SNOWFLAKE_JOBS_LIST = "snowflake_jobs_list",
  DBT_JOB = "dbt_job",
  STREAMLIT = "streamlit",
  NOTEBOOK = "notebook",
  STORED_PROCEDURE = "stored_procedure",
  SNOWFLAKE_QUERIES_LIST = "snowflake_queries_list",
  AI_SERVICES = "ai_services",
  TABLEAU_JOB = "tableau_job",
  DATABRICKS_SUMMARY = "databricks_summary",
  DATABRICKS_DISCOVER = "databricks_discover",
  DATABRICKS_WAREHOUSE = "databricks_warehouse",
  DATABRICKS_CLUSTER = "databricks_cluster",
  DATABRICKS_SKU_COST = "databricks_sku_cost",
  DATABRICKS_WORKSPACES_COST = "databricks_workspaces_cost",
  DATABRICKS_QUERY = "databricks_query",
  DATABRICKS_JOB = "databricks_job",
  DATABRICKS_USER = "databricks_user",
  DATABRICKS_AIML = "databricks_aiml",
  DATABRICKS_MODEL_SERVING = "databricks_model_serving",
  DATABRICKS_VECTOR_SEARCH = "databricks_vector_search",
}

export interface UserView extends Record<string, unknown> {
  entity_type: PlaygroundUserViewEntities;
  path?: string;
  start_date?: string;
  end_date?: string;
}

export interface PlaygroundContext extends Record<string, unknown> {
  user_view: UserView;
}

export type ChatbotProps = Pick<ChatbotProviderProps, "initialMessage" | "helloMessage">;

export interface Session {
  context: PlaygroundContext;
  sessionId: string | null;
  chatStatus: ChatEventStatus;
}

export interface PlaygroundStateProps {
  sessions: Record<string, Session>;
  currentSessionId: string | null;
  isPlaygroundPopoverOpen: boolean;
  chatbotProps: ChatbotProps;
  forceNewSession: number | null;
}

export interface PlaygroundStateWithCurrentSession extends PlaygroundStateProps {
  currentSession: Session | null;
}

export interface PlaygroundContextProps {
  state: PlaygroundStateProps;
  dispatch: React.Dispatch<UnknownAction>;
}
